import React, { useState, useEffect, useRef } from 'react';

function parseBold(text) {
  const parts = (text || '').split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) => i % 2 === 1 ? <strong key={i}>{part}</strong> : part);
}

export default function TrainingAccordionSection({ section, onReady }) {
  const raw = section?.accordionContent?.items ?? section?.accordionContent;
  const items = Array.isArray(raw) ? raw : raw ? Object.values(raw) : [];
  const [openedItems, setOpenedItems] = useState({});
  const [openIdx, setOpenIdx] = useState(null);
  const readyFiredRef = useRef(false);
  const onReadyRef = useRef(onReady);
  useEffect(() => { onReadyRef.current = onReady; });

  useEffect(() => {
    if (!readyFiredRef.current && items.length > 0 && Object.keys(openedItems).length === items.length) {
      readyFiredRef.current = true;
      onReadyRef.current?.();
    }
  }, [openedItems, items.length]);

  if (items.length === 0) return <div className="text-muted fst-italic">Sin items configurados.</div>;

  const handleOpen = (i) => {
    const isOpen = openIdx === i;
    setOpenIdx(isOpen ? null : i);
    if (!isOpen) setOpenedItems(prev => ({ ...prev, [i]: true }));
  };


  return (
    <div className="tacs-accordion">
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        return (
          <div key={i} style={{gap:'5px'}} className={`border ${isOpen ? 'border-primary' : openedItems[i] ? 'border-success' : 'border-secondary'} rounded mb-2 overflow-hidden`}>
            <button
              className="w-100 text-start d-flex justify-content-between align-items-center px-3 py-2 fw-semibold"
              style={{ gap: '5px', background: isOpen ? '#f0f9ff' : openedItems[i] ? '#f0fdf4' : '#f8fafc', border: 'none', cursor: 'pointer' }}
              onClick={() => handleOpen(i)}
            >
              <span className="d-flex align-items-center gap-2">
                {openedItems[i] && <i className="fas fa-check-circle text-success" style={{ fontSize: '0.85rem' }} />}
                {item.title}
              </span>
              <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} text-muted`} style={{ fontSize: '0.75rem' }} />
            </button>
            <div
              style={{
                maxHeight: isOpen ? 600 : 0,
                opacity: isOpen ? 1 : 0,
                overflow: 'hidden',
                transition: 'max-height 0.3s ease, opacity 0.2s ease',
              }}
            >
              <div
                className="px-3 py-2 text-muted"
                style={{ whiteSpace: 'pre-wrap', borderTop: '1px solid #e2e8f0' }}
              >
                {item.body ? parseBold(item.body) : <em>Sin contenido.</em>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
